// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-image-docs',
    templateUrl: './image.docs.generated.html',
})
export class UIImageDocs { }
